import $ from 'cash-dom';
import prestashop from 'prestashop';
import setUpAddress from './checkout/address';
import setUpDelivery from './checkout/delivery';
import setUpPayment from './checkout/payment';
import Steps from './checkout/steps';

function setUpCheckout() {
  setUpAddress();
  setUpDelivery();
  setUpPayment();

  handleCheckoutStepChange();
  handleSubmitButton();
}

function handleCheckoutStepChange() {
  const steps = new Steps();
  const clickableSteps = steps.getClickableSteps();

  console.log("LS: init checkout steps");
  clickableSteps.on('click', (event) => {
    const clickedStep = Steps.getClickedStep(event);

    if (!clickedStep.isUnreachable()) {
      steps.makeCurrent(clickedStep);
      if (clickedStep.hasContinueButton()) {
        clickedStep.disableAllAfter();
      } else {
        clickedStep.enableAllBefore();
      }
    }
    
    prestashop.emit('changedCheckoutStep', {event});
  });
}

function handleSubmitButton() {
  // prevents rage clicking on submit button and related issues
  const formSelector = prestashop.selectors.checkout.form;
  $(formSelector).submit(function (e) {
    console.log('handle submit form');
    console.log(this);

    if ($(this).data('disabled') === true) {
      e.preventDefault();
      console.log('submit: prevent');
    }else{
        console.log('submit: continue event');
    }
    
    $(this).data('disabled', true);
    $('button[type="submit"]', this).addClass('disabled');
  });
}

$(document).ready(() => {
  if ($('#checkout').length === 1) {
    setUpCheckout();
  }
});
